module.exports = __webpack_public_path__ + "media/images/icons/twotone/plus-circle-2d5cbca37d0b1d174316c5d8346fca16.svg";